import IPC from '../helpers/ipc';
import store from '../helpers/store';
import * as WidgetActions from '../components/layers/widget/actions';
import { INVITE_TYPE } from './types';
import { LAYERS } from '../components/layers/types';

const INVITE_RESULT = {
    ACCEPT: 'accept',
    TIMEOUT: 'timeout',
    PAGE_EXIT: 'pageExit',
    CANCEL: 'cancel'
};

class Tracker {
    getActiveConfiguration() {
        const state = store.getState();
        let config;

        if (state.main.isPopupLayerEnabled) {
            config = state.config.popup;
        } else if (state.main.isWidgetLayerEnabled) {
            config = state.config.widget;
        }

        if (!config) {
            return null;
        }

        if (Array.isArray(config) && config.length > 0) {
            return config[config.length - 1];
        } else {
            return config;
        }
    }

    getActiveLayer() {
        const state = store.getState();
        if (state.main.isPopupLayerEnabled) {
            return LAYERS.POPUP;
        } else if (state.main.isWidgetLayerEnabled) {
            return LAYERS.WIDGET;
        }
    }

    sendEvent(event, data) {
        let payload = { event };
        if (data) {
            payload = { ...payload, data };
        }
        IPC.sendEvent('TRACKER_EVENT', payload);
    }

    sendGAEvent(event, payload) {
        IPC.sendEvent('TRACKER_VIEW_RESULT', {
            event,
            ...payload
        });
    }

    sendInviteResult(code, media) {
        const state = store.getState();
        const config = this.getActiveConfiguration();

        if (!config || !state) {
            return;
        }

        if (
            state.widget &&
            !state.widget.inviteResultSend &&
            state.config.widget &&
            !state.config.widget.disableSendInviteResults
        ) {
            IPC.sendEvent('TRACKER_INVITERESULT', {
                code,
                media,
                engagementID: state.config.widget.engagementID
            });
            WidgetActions.inviteResultSend();
        }
    }

    sendViewResult(media, event, source, args) {
        const config = this.getActiveConfiguration();

        if (!config || !config.engagementID) {
            return;
        }

        const layer = this.getActiveLayer();
        if (source === 'CMB' && event === 'leadCMBShow' && layer === LAYERS.WIDGET) {
            return;
        }

        const getContactOptions = () => {
            if (!config.contactOptions) {
                return '';
            }

            let options = [];
            config.contactOptions.cmbAvailable && options.push('CMB');
            config.contactOptions.chatAvailable && options.push('CHAT');
            return options.join('|');
        };

        IPC.sendEvent('TRACKER_VIEW_RESULT', {
            media,
            event,
            cmbType:
                config.eipView && layer === LAYERS.POPUP
                    ? 'exitIntent'
                    : config.defaultView === 'cmbPopup'
                    ? 'popup'
                    : 'widget',
            engagementID: config.engagementID,
            contactOptions: getContactOptions(),
            ...(args?.dialogueTag && {
                dialogueTag: args.dialogueTag
            })
        });
    }

    showPhoneNumber() {
        this.sendViewResult(INVITE_TYPE.SHOW_CALL);
        const config = this.getActiveConfiguration();
        if (config && config.engagementID) {
            this.sendEvent('widgetOnClick', {
                element: 'showPhoneNumber',
                engagementID: config.engagementID
            });
        }
    }

    acceptCallInvite() {
        this.sendInviteResult(INVITE_RESULT.ACCEPT, INVITE_TYPE.CALL);
        this.sendViewResult(INVITE_TYPE.CALL);
    }

    acceptCallbackInvite() {
        // this.sendInviteResult(INVITE_RESULT.ACCEPT, INVITE_TYPE.CALLBACK);
        this.sendViewResult(INVITE_TYPE.CALLBACK, 'leadCMBShow');
    }

    acceptChatInvite() {
        this.sendViewResult(INVITE_TYPE.CHAT);
    }

    acceptChatInviteSuccess() {
        this.sendInviteResult(INVITE_RESULT.ACCEPT, INVITE_TYPE.CHAT);
        this.sendViewResult(INVITE_TYPE.CHAT_SUCCESS);
    }

    cancelInvite() {
        this.sendInviteResult(INVITE_RESULT.CANCEL);
    }

    timeOutInvite() {
        this.sendInviteResult(INVITE_RESULT.TIMEOUT);
    }

    pageExitInvite() {
        this.sendInviteResult(INVITE_RESULT.PAGE_EXIT);
    }
}

export default new Tracker();
